import { useCallback } from 'react'
import type { ApplicationFormState } from '../../types'
import { getRegisterFieldErrors } from '../../utils/validation'

type UseApplicationFormValidationActionsArgs = {
  handleRegister: () => Promise<void>
  state: ApplicationFormState
}

export function useApplicationFormValidationActions({
  handleRegister,
  state
}: UseApplicationFormValidationActionsArgs) {
  const validateAndRegister = useCallback(() => {
    const errors = getRegisterFieldErrors(
      state.formData,
      state.addressStateRestriction
    )

    state.setFieldErrors(errors)

    if (Object.keys(errors).length === 0) {
      void handleRegister()
    }
  }, [handleRegister, state])

  return {
    validateAndRegister
  }
}
